import ENV from 'tio-employee/config/environment';
import createStore from 'tio-data/store-factory';
import { impersonationProvider, demoProvider } from 'tio-data/app-context';
import { manifest } from 'tio-employee/schemas';

// WarpDrive store: built by the
// module-scope-safe factory (ADR-001). Auth state, the request-event
// subscription, AND the owner-bound impersonation/demo providers are wired by
// the `auth-context` instance-initializer at boot; the request layer reads them
// per request through the stable auth-context / app-context containers, so this
// store carries no per-instance closures.
// Schemas for every type tio-employee reads/mutates are registered via the
// manifest (LegacyMode); remaining types fall back to compat-modules Models
// during the transition.
// jsonApiKeyFormat is 'camelized': the store sends `x-json-api-key-format: camelized`
// and the cache/wire keys camelize (TioTypeNormalizationHandler). contentType/accept
// are JSON:API media types. response/demo/impersonation/sessionRenewal behavior:
//   - invalidate (session-fatal) on 401; toast on 400/403/422
//   - sessionRenewal { passToken: false }
//   - impersonation gates mutations during impersonated sessions
//   - demo short-circuits store-routed requests while demo mode is active
const AppStore = createStore(
  {
    apiKey: ENV.apiKey,
    contentType: 'application/vnd.api+json',
    accept: 'application/vnd.api+json',
    jsonApiKeyFormat: 'camelized',
    sessionRenewal: {
      passToken: false,
    },
    impersonation: impersonationProvider,
    response: {
      invalidateStatuses: [401],
      toastStatuses: [400, 403, 422],
    },
    demo: demoProvider,
  },
  manifest
);

export default AppStore;
export type TioEmployeeStore = InstanceType<typeof AppStore>;
